import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Protect.css";

function Protect({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getAuth();
  }, []);

  const getAuth = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.get(`${process.env.REACT_APP_BACKEND}/api/auth`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      setIsAuthenticated(true);
    } catch (error) {
      navigate("/login");
    }
  };

  return (
    <>
      {isAuthenticated ? (
        children
      ) : (
        <div className="loading">
          <div className="loader"></div>
        </div>
      )}
    </>
  );
}

export default Protect;
